import type { FindingCategory } from "./Finding";

// Место категории в «светофоре» и в секциях разбора. `Record` по union из контракта:
// новая категория на бэкенде не соберётся, пока ей не назначат место.
const CATEGORY_ORDER: Record<FindingCategory, number> = {
  buy: 0,
  farm: 1,
  deaths: 2,
  fights: 3,
  skills: 4,
};

export const FINDING_CATEGORIES: readonly FindingCategory[] = (
  Object.keys(CATEGORY_ORDER) as FindingCategory[]
).sort((a, b) => CATEGORY_ORDER[a] - CATEGORY_ORDER[b]);
